import '../Dashboard.css';
import { Form, InputField, TextAreaField } from '@/components/Form';
import { z } from 'zod';
import { useRef, useState } from 'react';
import i18next from 'i18next';
import { Button } from '@/components/Elements';
import { AdminLayout } from '@/components/Layout/AdminLayout';

const ViewHelpSupport = () => {
  const [loading, setLoading] = useState(false);
  return (
    <AdminLayout title="">
      <div className="profile-tab">
        <div
          className="profile-container add-ticket border rounded-lg"
          style={{ background: '#FAFAFA' }}
        >
          <h4 className="text-dark f-18 font-semibold border-btm p-3">Details</h4>
          <div className="profile-content pass-form tikt p-3">
          <div className="person-inf">
              <div className="info-item">
                <p className="gry"> Name:</p>
                <p className="font-semibold text-black">Alex</p>
              </div>
              <div className="info-item">
                <p className="gry">Title:</p>
                <p className="font-semibold text-black">Lorem Ipsum</p>
              </div>
              <div className="info-item">
                <p className="gry">Date:</p>
                <p className="font-semibold text-black">09-01-2025</p>
              </div>
              <div className="info-item">
                <p className="gry">Time:</p>
                <p className="font-semibold text-black">12:59:23 PM</p>
              </div>
              <div className="info-item w-100">
                <p className="gry"> Description:</p>
                <p className="font-semibold text-black">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default ViewHelpSupport;
